export const fundListNn = {
    errors: {
        fundList: {
            fetchErrorTitle: 'Vi får ikkje henta fonda akkurat no',
            paginationFetchErrorTitle: 'Kunne ikkje laste fleire fond',
            paginationFetchErrorDetails: 'Orsak, noko gjekk gale ved lasting av fleire fond. Ver vennleg og prøv igjen, eller kom tilbake seinare.',
        },
    },
    fundList: {
        header: 'Fondslista',
        emptyState: 'Ingen fond er tilgjengelege akkurat no.',
        infoModal: {
            title: 'Forklaring til fondslista',
            openScreenReaderText: 'Forklaring til fondslista',
            closeScreenReaderText: 'Lukk',
            buttonText: 'Forklaring til fondslista',
        },
        symbolList: {
            morningstarSustainabilityRating: 'Berekrafts\u00ADrangering frå Morningstar',
            yearlyCost: 'Årleg kostnad',
            minimumAmount: 'Minste\u00ADbeløp',
            summaryRiskIndicator: 'Risiko',
            fundDevelopment: 'Verdi\u00ADutvikling',
            eikaFundAndOtherFunds: '“Eika-fond” og “Andre fond”',
            yearlyCostExample: 'Årleg kostnad %',
            minimumAmountExample: 'Min. kr',
            fundDevelopmentExample: '+ % eller - %',
        },
        fundTypes: {
            equity: 'Aksjefond',
            fixedIncome: 'Rentefond',
            balanced: 'Kombinasjons\u00ADfond',
            alternative: 'Alternativt fond',
            index: 'Indeksfond',
        },
        regionLabels: {
            norway: 'Noreg',
            europeNorth: 'Norden',
            sweden: 'Sverige',
            baltics: 'Baltiske statar',
            europe: 'Europa',
            global: 'Globalt',
            unitedStatesOfAmerica: 'USA (Dei forente statane)',
            asiaPacific: 'Asia-Stillehavs\u00ADregionen',
            asiaPacificExJapanExAustralia: 'Asia-Stillehavs\u00ADregionen ekskl. Japan og Australia',
            japan: 'Japan',
            india: 'India',
            brazil: 'Brasil',
            china: 'Kina',
            chinaGreater: 'Større Kina (inkl. Hongkong og Taiwan)',
            thailand: 'Thailand',
            latinAmerica: 'Latin-Amerika',
            bricBrazilRussiaIndiaAndChina: 'BRIC (Brasil, Russland, India og Kina)',
            europeEmergingMarkets: 'Fram\u00ADvoksande marknader i Europa',
            globalEmergingMarkets: 'Globale fram\u00ADvoksande marknader',
            emergingEuropeMiddleEastAndAfrica: 'Fram\u00ADvoksande marknader i Europa, Midtausten og Afrika',
        },
        riskLabel: 'Risiko',
        summaryRiskIndicatorAriaLabel: 'Risiko: {} av {}',
        minimumAmountLabel: 'Min. {}',
        minimumAmountAriaLabel: 'Minstebeløp: {}.',
        managementFeeLabel: 'Forvaltnings\u00ADhonorar',
        yearlyCostLabel: 'Årleg kostnad {}',
        yearlyCostAriaLabel: 'Årleg kostnad: {}.',
        developmentCardLabel: '{} år',
        developmentAriaLabel: '{}-års verdiutvikling: {} prosent.',
        morningstarSustainabilityRatingAriaLabel: 'Morningstar berekraftsrangering: {} av 5.',
        notAvailableForOneTimePurchase: 'Fondet tilbyr berre månadsleg sparing',
        notAvailableForPeriodicPurchase: 'Fondet tilbyr berre ein\u00ADgongs\u00ADkjøp',
        controlsRegionLabel: 'Søk og filtrer fond',
        searchResultsHeading: 'Søkjeresultat',
        numberOfHits: '{} treff',
        sortedNumberOfHits: 'Sortert liste klar. {} treff',
        numberOfHitsWithFilters: '{} treff ({} aktive filtre)',
        noResults: {
            ordinary: {
                title: 'Ingen treff i søk og filter',
                filtersAndSearchBody: 'Ingen fond samsvarar med søket og filtera. Prøv å justere søket eller fjerne nokre av filtera. Søk og filter påverkar ikkje tilrådingane frå fondsguiden.',
                filtersOnlyBody: 'Ingen fond samsvarar med filtera. Prøv å justere eller fjerne nokre av filtera. Søk og filter påverkar ikkje tilrådingane frå fondsguiden.',
                searchOnlyBody: 'Ingen fond samsvarar med søket. Prøv å justere søket. Søk og filter påverkar ikkje tilrådingane frå fondsguiden.',
                unfilteredBody: 'Fondslista har ingen treff. Søk og filter påverkar ikkje tilrådingane frå fondsguiden.',
            },
            title: 'Ingen treff på vala dine',
            filtersAndSearchBody: 'Prøv å justere søket eller fjerne nokre av filtera for å finne fond som passar.',
            filtersOnlyBody: 'Prøv å justere eller fjerne nokre av filtera for å finne fond som passar.',
            searchOnlyBody: 'Prøv å justere søket for å finne fond som passar.',
        },
        sectionTags: {
            eikaFundsTag: 'Eika-fond',
            otherFundsTag: 'Andre fond',
            eikaFundsTagFiltered: 'Treff i Eika-fond',
            otherFundsTagFiltered: 'Andre treff',
        },
        search: {
            closeSearchButtonLabel: 'Lukk og nullstill søk',
            openSearchButtonLabel: 'Søk i fondslisten',
            searchInputAriaLabel: 'Søk etter fond',
        },
        filters: {
            clearAllFilters: 'Fjern alle filtera',
            resetFilters: 'Nullstill',
            filterButton: 'Filter',
            filterButtonScreenReaderText: 'Filtrer fondslisten',
            filterModalTitle: 'Filtrer fonda',
            closeFilterModalScreenReaderText: 'Lukk filter',
            riskFilterLabel: 'Risiko\u00ADnivå',
            riskChipLabel: 'Risiko',
            morningstarSustainabilityRatingFilterLabel: 'Berekrafts\u00ADrangering',
            morningstarSustainabilityRatingChipLabel: 'Berekraft',
            regionFilterLabel: 'Region',
            regionFilterOptions: {
                global: 'Globalt marked',
                europeNorth: 'Europa (Nord-Europa)',
                norway: 'Noreg',
            },
            fundTypeFilterLabel: 'Fondstype',
            totalFunds: '{} fond',
            showResults: 'Vis {} treff',
            noHitsButton: '0 treff',
            infoButtonScreenReaderText: 'Opne forklaring om {}',
            indexFundOnlyLabel: 'Vis berre indeksfond',
            practicalFiltersLabel: 'Praktiske filter',
            askCompatibleOnlyLabel: 'ASK-kompatibel',
            askCompatibleOnlyVisibleText: 'ASK',
            activeFiltersHeading: 'Aktive filter',
            removeFilterAriaLabel: 'Fjern filter: {}',
        },
        queryPresets: {
            groupLabel: 'Framheva hurtigfiltar',
            fundGuideLabel: 'Finn din fondstype',
            closeFundGuideLabel: 'Lukk fondsguide',
            highestSustainabilityRating: 'Best rangert berekrafts\u00ADrisiko',
            nordicFunds: 'Norske og nordiske fond',
            globalFunds: 'Globale fond \u2013 brei dekning',
        },
        resultsCount: {
            ordinaryMatchesCountLabel: 'Treff i søk og filter: {} fond',
            visibleFundsLabel: 'Viser {} fond',
            eikaFundsListLabel: 'Liste med {} Eika-fond.',
            otherFundsListLabel: 'Liste med {} andre fond.',
            allFundsListLabel: 'Liste med {} fond.',
        },
    },
};
//# sourceMappingURL=data:application/json;base64,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